import React from 'react'

import { styled } from '@mui/material/styles'
import ImageList from '@mui/material/ImageList'
import ImageListItem from '@mui/material/ImageListItem'

import { QuizContextAction } from '../../contexts/quizContext'
import ImageOption from './ImageOption'

import { O, T } from '../../utils/Typography'
import { useWindowSize } from '../../utils/window'
import { OptionId } from '../../data/options'
import useMediaQuery from '@mui/material/useMediaQuery'
// import { shuffleArray } from '../../utils/functions'

const PREFIX = 'ImageQuestion'

export type ImageQuestionProps = {
  options: Array<OptionId>
  currentQuizIndex: number
  questionText: string
  subText?: string
  preText?: string
  reduceQuizData: React.Dispatch<QuizContextAction>
}

const ImageQuestion = (props: ImageQuestionProps) => {
  const {
    options,
    currentQuizIndex,
    questionText,
    subText,
    preText,
    reduceQuizData,
  } = props

  const nonMobileScreen = useMediaQuery('(min-width:900px')
  // const mobileScreen = true

  console.log('ImageQuestion reload', props)
  const classes = {
    root: `${PREFIX}-root`,
  }
  const Root = styled('div')(({ theme }) => ({
    [`&.${classes.root}`]: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      overflow: 'hidden',
      backgroundColor: theme.palette.background.paper,
      maxWidth: '1600px', // 3 columns
      width: '95%', // leaves some margin on sides
    },
  }))

  // const [orderedOptions, setOrderedOptions] = React.useState(options)
  // const landscape = width > height;
  const columns = nonMobileScreen ? 3 : 2

  // React.useEffect(() => {
  //   setOrderedOptions(shuffleArray(options))
  // }, [options])

  const onClickImageOption: (
    key: OptionId,
    value: boolean,
  ) => void = React.useCallback(
    (key: OptionId, value: boolean) => {
      reduceQuizData({
        type: 'update_quiz_answers',
        payload: {
          currentQuizIndex: currentQuizIndex,
          key: key,
          value: value,
        },
      })
    },
    [currentQuizIndex, reduceQuizData],
  )

  return (
    <Root className={classes.root}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}>
        {preText && (
          <T variant='body1' style={{ marginBottom: 10 }}>
            {preText}
          </T>
        )}
        <T variant='h4' style={{ marginBottom: 10 }}>{`${
          currentQuizIndex + 1
        }. ${questionText}`}</T>
        {subText && (
          <T variant='body1' style={{ marginBottom: 10 }}>
            {subText}
          </T>
        )}
        <T variant='h4' style={{ marginBottom: 20, fontSize: '1.2rem' }}>
          <O>(Select all that apply)</O>
        </T>
        <br />
      </div>
      <ImageList
        style={{ overflowY: 'hidden', width: 700 }}
        gap={8}
        cols={columns}>
        {options.map((key) => (
          <ImageListItem key={key + '_tile'}>
            <ImageOption
              option_key={key}
              onClickImageOption={onClickImageOption}
            />
          </ImageListItem>
        ))}
      </ImageList>
    </Root>
  )
}

export default ImageQuestion
